import { EntitySales } from "../../entity/EntitySales";

export class DtoSalessPutRes extends EntitySales {}
